import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { SaveUserStateToServerHelper } from "../Helper";
import { start, changeView, startTyping } from "../../actions/assessment";
import imgBulb from "./../../assets/img/icon-bulb.svg";
import config from "../../config/config-secret.json";

import { Translate } from "react-redux-i18n";

export class GeneralInstruction extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  start = () => {
    if (this.props.is_ptsd) {
      this.props.show_ptsd();
      return;
    }

    if (this.props.assessment.current_question_number === 1) {
      const tester_id = this.props.assessment.tester_id;

      axios
        .post(config.API_URL + "/administer_test/started/", {
          tester_id: tester_id,
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          if (
            ["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name)
          ) {
            this.props.start_typing("typing_test");
          } else if (
            ["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name)
          ) {
            this.props.start_typing("data_entry_test");
          } else {
            this.props.start();
          }
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.log(error);
          alert("Something went wrong. Please refresh the page.");
        });
    } else {
      if (["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name)) {
        this.props.start_typing("typing_test");
      } else if (
        ["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name)
      ) {
        this.props.start_typing("data_entry_test");
      } else {
        this.props.start();
      }
    }
  };

  render() {
    const i18n = require("react-redux-i18n").I18n;
    let instruct_sub_lead = null;

    if (["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name)) {
      instruct_sub_lead = (
        <Translate value="instruct_sub_lead_practice_test_typing" />
      );
    } else {
      instruct_sub_lead = (
        <Translate value="instruct_sub_lead_practice_test_data_entry" />
      );
    }

    // Substitute the actual time limit to the instruction 
    let withTimeLimitInjected = this.props.instruction.replace("TO_BE_REPLACED", this.props.time_limit)

    return (
      <div className="main container-fluid h-100">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="test-instruction ">
                <div className="row  justify-content-center ">
                  <div className="col-md- ">
                    <h3 className="mt-5 mb-4">
                      <Translate value="instruct" />
                    </h3>
                    <div className="reminder">
                      <img
                        src={imgBulb}
                        className="d-table-cell"
                        width="30px"
                        height="30px"
                        alt={i18n.t("instruct")}
                      />
                      {[
                        "Typing Test V1",
                        "Typing Test V2",
                        "Data Entry V1",
                        "Data Entry V2",
                      ].includes(this.props.exam_name) ? (
                        <div>
                          <p className="lead mb-2">
                            <Translate value="instruct_lead" />
                          </p>
                          <p>{instruct_sub_lead}</p>
                        </div>
                      ) : (
                        <p className="lead">
                          <Translate value="instruct_lead" />
                        </p>
                      )}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: withTimeLimitInjected,
                      }}
                    ></div>
                    {![
                      "Typing Test V1",
                      "Typing Test V2",
                      "Data Entry V1",
                      "Data Entry V2",
                    ].includes(this.props.exam_name) && (
                      <p className="pt-2">
                        <Translate value="instruct_start" />
                      </p>
                    )}

                    <div className="mt-4">
                      <div className="button-wrap mt-md-5">
                        <button
                          onClick={this.start}
                          className="btn btn-main btn-global ord-1"
                        >
                          <Translate value="start" />
                        </button>
                        <button
                          onClick={this.props.exit_session}
                          className="btn btn-outline-white btn-global ord-2"
                          style={{paddingLeft: ".25rem", paddingRight: ".25rem"}}
                        >
                          <Translate value="exit_session" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  instruction: state.assessment.exams[state.assessment.exam_index].instruction,
  is_ptsd: state.assessment.exams[state.assessment.exam_index].is_ptsd,
  exam_index: state.assessment.exam_index,
  exam_name: state.assessment.exams[state.assessment.exam_index].name,
  time_limit: state.assessment.exams[state.assessment.exam_index].time_limit,
});

const mapDispatchToProps = (dispatch) => ({
  start: () => dispatch(start()),
  start_typing: (test_name) => dispatch(startTyping(test_name)),
  show_ptsd: () => dispatch(changeView("ptsd")),
  exit_session: () => dispatch(changeView("session_details")),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInstruction);
